var u = Object.defineProperty;
var p = (r, t, e) => t in r ? u(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e;
var i = (r, t, e) => p(r, typeof t != "symbol" ? t + "" : t, e);
import "oidc-client";
import "lodash-es";
import "nanoid";
import { storage as d } from "../../../utils/storage.js";
import "../../../date-D-6ewr4B.mjs";
import { A as h } from "../../../api-CZJ4bXCT.mjs";
import "../../../styled-qu50FBLM.mjs";
import "../../../utils/globalStyles.js";
const c = d(localStorage), a = class a {
  constructor() {
    /**
     * api request adapter object
     */
    i(this, "adapter");
    this.adapter = new h({
      baseURL: this.getUrlForEnvironment("prod"),
      responseType: "json",
      headers: {
        timeout: 60 * 10 * 1e3,
        "content-type": "application/json",
        accept: "application/json"
      }
    });
  }
  getUrlForEnvironment(t) {
    const e = t.indexOf("prod") !== -1, o = t.indexOf("stage") !== -1, s = e || o ? "transaction-services" : "transaction-services-nonprod";
    return `https://${e ? "api" : `api-${t}`}.webcore.${s}.service.vic.gov.au`;
  }
  getMenuFromCache() {
    try {
      const t = c.getItem(a.MENU_STORAGE_KEY), e = 15 * 60 * 1e3;
      if ("fetchTs" in t && "menu" in t && typeof t.fetchTs == "number" && t.fetchTs + e > Date.now())
        return t.menu;
    } catch {
    }
    return null;
  }
  cacheMenu(t) {
    c.setItem(a.MENU_STORAGE_KEY, { fetchTs: Date.now(), menu: t });
  }
  mapResponseToMegamenu(t) {
    const e = Object.values(t.items).reduce(
      (s, n) => (s[n.text] = n, s),
      {}
    ), o = (s) => s.map((n) => ({
      id: n.text,
      text: n.text,
      href: n.link,
      subItems: n.subItems ? o(n.subItems) : void 0
    }));
    return t.itemOrder.map((s) => {
      const n = e[s];
      return {
        id: n.value,
        text: n.text,
        href: "",
        subItems: o(n.links)
      };
    });
  }
  setEnvironment(t) {
    this.adapter.updateConfig({
      baseURL: this.getUrlForEnvironment(t)
    });
  }
  async getMegaMenuItems(t = !0) {
    if (t) {
      const s = this.getMenuFromCache();
      if (s !== null)
        return s;
    }
    const { data: e } = await this.adapter.getValue("/v1/megamenu"), o = this.mapResponseToMegamenu(e);
    return t && this.cacheMenu(o), o;
  }
};
i(a, "MENU_STORAGE_KEY", "sv.webcore.menu");
let m = a;
export {
  m as default
};
